import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { resetPassword } from '../../services/AuthService';

import uniLogo from './../../images/uniempleo-logo-nuevo.png';
import loginbg from '../../images/portada-uniempleo.png';

export function ResetPasswordPage(props) {
    const [token, setToken] = useState('');
    const [passwordNueva, setPasswordNueva] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [apiError, setApiError] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(props.location.search);
        const tokenParam = params.get('token');
        if (tokenParam) {
            setToken(tokenParam);
        }
    }, [props.location.search]);

    function validate() {
        const newErrors = {};
        if (!passwordNueva) {
            newErrors.passwordNueva = 'La nueva contraseña es requerida';
        } else if (passwordNueva.length < 6) {
            newErrors.passwordNueva = 'La contraseña debe tener al menos 6 caracteres';
        }
        if (!confirmPassword) {
            newErrors.confirmPassword = 'Debes confirmar la contraseña';
        } else if (passwordNueva !== confirmPassword) {
            newErrors.confirmPassword = 'Las contraseñas no coinciden';
        }
        return newErrors;
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setApiError('');

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors({});

        if (!token) {
            setApiError('El enlace de recuperación no es válido. Por favor solicita uno nuevo.');
            return;
        }

        setLoading(true);
        try {
            await resetPassword(token, passwordNueva);
            setSuccess(true);
        } catch (err) {
            const message =
                err?.response?.data?.message ||
                'El enlace de recuperación es inválido o ha expirado. Por favor solicita uno nuevo.';
            setApiError(message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="page-wraper" style={{ height: '100vh', overflow: 'hidden', margin: 0, padding: 0 }}>
            <div className="page-content bg-white login-style2" style={{ height: '100vh', overflow: 'hidden', margin: 0, padding: 0 }}>
                <div
                    className="dez-bnr-inr dez-bnr-inr-md overlay-black-middle"
                    style={{ backgroundImage: `url(${loginbg})`, height: '100vh', margin: 0, padding: 0 }}
                >
                    <div className="section-full" style={{ height: '100vh', margin: 0, padding: 0 }}>
                        <div className="container-fluid p-a0" style={{ height: '100vh', margin: 0, padding: 0, overflow: 'hidden' }}>
                            <div className="row" style={{ height: '100vh', margin: 0, padding: 0 }}>
                                <div className="col-lg-4 col-md-4 col-sm-12 p-a0" style={{ height: '100vh', overflow: 'hidden' }}>
                                    <div
                                        className="submit-resume p-a40 seth bg-white"
                                        style={{
                                            height: '100vh',
                                            borderRadius: 0,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            overflowY: 'auto',
                                        }}
                                    >
                                        <div className="nav">
                                            <div className="logo m-b30">
                                                <Link to="/"><img src={uniLogo} alt="UNIEMPLEO" style={{ maxWidth: '180px' }} /></Link>
                                            </div>

                                            <div className="col-12 p-a0">
                                                <h3 className="m-b20" style={{ fontSize: '1.8rem', fontWeight: 700, color: '#333' }}>
                                                    Restablecer Contraseña
                                                </h3>
                                                <p className="font-weight-600 m-b30" style={{ color: '#666', fontSize: '0.95rem' }}>
                                                    Ingresa tu nueva contraseña. El enlace es válido por 15 minutos.
                                                </p>

                                                {apiError && (
                                                    <div
                                                        style={{
                                                            backgroundColor: '#f8d7da',
                                                            color: '#721c24',
                                                            border: '1px solid #f5c6cb',
                                                            borderRadius: '4px',
                                                            padding: '12px 15px',
                                                            marginBottom: '20px',
                                                            fontSize: '0.9rem',
                                                        }}
                                                    >
                                                        <i className="fa fa-exclamation-circle" style={{ marginRight: '8px' }}></i>
                                                        {apiError}
                                                    </div>
                                                )}

                                                {success ? (
                                                    <>
                                                        <div
                                                            style={{
                                                                backgroundColor: '#d4edda',
                                                                color: '#155724',
                                                                border: '1px solid #c3e6cb',
                                                                borderRadius: '4px',
                                                                padding: '15px',
                                                                marginBottom: '20px',
                                                            }}
                                                        >
                                                            <i className="fa fa-check-circle" style={{ marginRight: '8px' }}></i>
                                                            Contraseña restablecida exitosamente. Ya puedes iniciar sesión con tu nueva contraseña.
                                                        </div>
                                                        <div className="m-t20">
                                                            <Link
                                                                to="/login"
                                                                className="site-button btn-block"
                                                                style={{
                                                                    backgroundColor: '#009247',
                                                                    borderColor: '#009247',
                                                                    padding: '12px',
                                                                    fontSize: '1rem',
                                                                    fontWeight: 600,
                                                                    display: 'block',
                                                                    textAlign: 'center',
                                                                    color: '#fff',
                                                                    textDecoration: 'none',
                                                                    borderRadius: '4px',
                                                                }}
                                                            >
                                                                Ir al inicio de sesión
                                                            </Link>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <form onSubmit={handleSubmit} className="col-12 p-a0" noValidate>
                                                        <div className="form-group m-b20">
                                                            <label
                                                                className="font-weight-600"
                                                                htmlFor="rp-password"
                                                                style={{ marginBottom: '8px', display: 'block' }}
                                                            >
                                                                Nueva Contraseña *
                                                            </label>
                                                            <div className="input-group">
                                                                <input
                                                                    id="rp-password"
                                                                    type="password"
                                                                    className="form-control"
                                                                    placeholder="Mínimo 6 caracteres"
                                                                    value={passwordNueva}
                                                                    onChange={(e) => setPasswordNueva(e.target.value)}
                                                                    style={{ padding: '12px 15px' }}
                                                                    autoComplete="new-password"
                                                                />
                                                            </div>
                                                            {errors.passwordNueva && (
                                                                <div className="text-danger fs-12 mt-1">{errors.passwordNueva}</div>
                                                            )}
                                                        </div>

                                                        <div className="form-group m-b25">
                                                            <label
                                                                className="font-weight-600"
                                                                htmlFor="rp-confirm"
                                                                style={{ marginBottom: '8px', display: 'block' }}
                                                            >
                                                                Confirmar Contraseña *
                                                            </label>
                                                            <div className="input-group">
                                                                <input
                                                                    id="rp-confirm"
                                                                    type="password"
                                                                    className="form-control"
                                                                    placeholder="Repite la nueva contraseña"
                                                                    value={confirmPassword}
                                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                                    style={{ padding: '12px 15px' }}
                                                                    autoComplete="new-password"
                                                                />
                                                            </div>
                                                            {errors.confirmPassword && (
                                                                <div className="text-danger fs-12 mt-1">{errors.confirmPassword}</div>
                                                            )}
                                                        </div>

                                                        <div className="m-t30">
                                                            <button
                                                                type="submit"
                                                                className="site-button btn-block"
                                                                style={{
                                                                    backgroundColor: loading ? '#cccccc' : '#009247',
                                                                    borderColor: loading ? '#cccccc' : '#009247',
                                                                    padding: '12px',
                                                                    fontSize: '1rem',
                                                                    fontWeight: 600,
                                                                    marginBottom: '15px',
                                                                    cursor: loading ? 'not-allowed' : 'pointer',
                                                                    opacity: loading ? 0.6 : 1,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    gap: '10px',
                                                                }}
                                                                disabled={loading}
                                                            >
                                                                {loading ? (
                                                                    <>
                                                                        <i className="fa fa-spinner fa-spin"></i>
                                                                        <span>Restableciendo...</span>
                                                                    </>
                                                                ) : (
                                                                    'Restablecer Contraseña'
                                                                )}
                                                            </button>
                                                        </div>

                                                        {apiError && (
                                                            <div className="text-center" style={{ marginTop: '10px' }}>
                                                                <Link
                                                                    to="/auth/forgot-password"
                                                                    style={{ color: '#00004C', fontSize: '13px', fontWeight: '600', textDecoration: 'none' }}
                                                                >
                                                                    Solicitar un nuevo enlace de recuperación
                                                                </Link>
                                                            </div>
                                                        )}
                                                    </form>
                                                )}

                                                <div className="text-center" style={{ marginTop: '20px' }}>
                                                    <Link to="/login" style={{ color: '#666', fontSize: '13px', textDecoration: 'none' }}>
                                                        ← Volver al inicio de sesión
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className="bottom-footer clearfix row text-center"
                                            style={{ padding: '0px 0 8px', marginTop: '20px', borderTop: '1px solid #e9ecef' }}
                                        >
                                            <div className="col-lg-12 text-center">
                                                <span style={{ fontSize: '11px', color: '#999' }}>
                                                    © {new Date().getFullYear()} UNIEMPLEO - Universidad del Caribe. Todos los derechos reservados.
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
